import React, { ReactElement } from "react"
import styled from "styled-components"
import i18n from "live/services/i18n"

const Editor = () => {
  return function EditorWrapper(): ReactElement {
    return (
      <EditorContainer className="editor-container default-editor">
        <DefaultEditorMessageContainer>
          <DefaultEditorMessageText className="asset-selector__empty__text">
            {i18n(
              "Filters and settings are displayed in visualization mode only."
            )}
            <br />
            {i18n("Save this widget and return to the dashboard.")}
          </DefaultEditorMessageText>
        </DefaultEditorMessageContainer>{" "}
      </EditorContainer>
    )
  }
}

const DefaultEditorMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 5%;
`

const DefaultEditorMessageText = styled.div`
  color: #666;
  font-size: 36px;
  font-style: italic;
  line-height: normal;
  text-align: center;
`

const EditorContainer = styled.div`
  display: flex;
  flex: 1 1 auto;
  > div:first-child {
    width: 100%;
  }
  .widget-footer {
    position: absolute !important;
    left: 0;
    bottom: 0;
  }
`
export default Editor
